/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HpeComponent } from '../../../resources/hpe-details.model';

@Component({
  standalone: false,
  selector: 'gh-hpe-details-cc-item',
  templateUrl: 'hpe-details-cc-item-component.component.html',
  styleUrls: ['hpe-details-cc-item-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HpeDetailsCcItemComponentComponent {
  @Input() component: HpeComponent;
}
